import { INavigationTrackedRouteProps as INavigationTrackedRoute } from './NavigationTrackedRoute'
import SummaryNavigation, { ISummaryNavigationProps } from './SummaryNavigation'

export type INavigationTrackedRouteProps = INavigationTrackedRoute
export { ISummaryNavigationProps }
export default SummaryNavigation
